<template>
  <div class="wrapper-full nibut">
    <div v-if="!isNewPupilCorneadia">
      <el-container>
        <el-main :style="`height:${dispH}px;width:1360px`" class="border-normal">
          <el-container>
            <el-main>
              <ImageBox
                :src="src"
                :width="dispW - 500 - 10"
                :height="dispH - 160"
                :focus="true"
                :colorHex="'#0f0'"
                :info="getInfo()"
                :proc="getProc()"
                :eyetype="currentEye"
                currentUnit="mm"
                :currentPhoto="''"
                curPage="pupilcorneadia"
                :edges="data2Imgbox"
                @update="update"
                @init-drawtype="btnDrawToolChange"
                @edge-changed="onEdgeChanged"
                :graphMode="graphMode"
              />
            </el-main>
            <el-footer>
              <el-row>
                <el-col :span="12">
                  <div
                    style="
                      height: 100%;
                      width: 100%;
                      display: flex;
                      align-items: center;
                      height: 100px;
                      padding-left: 150px;
                    "
                  >
                    <drawType
                      v-if="drawTypeShow"
                      SubPage="PupilCornea"
                      :toolsBoxWidth="400"
                      :toolsBoxHeight="80"
                      v-model="graphMode"
                    />
                  </div>
                </el-col>
                <!-- <el-col :span="12">
                <div class="radioContainer">
                  <el-radio
                    v-model="currentMode"
                    label="pupildia"
                    border
                    @change="selectItem('pupildia')"
                    >{{ $t('langcfg.txtPupil') }}</el-radio
                  >
                  <el-radio
                    v-model="currentMode"
                    label="corneadia"
                    border
                    @change="selectItem('corneadia')"
                    >{{ $t('langcfg.txtCornea') }}</el-radio
                  >
                </div>
              </el-col> -->
              </el-row>
            </el-footer>
          </el-container>
        </el-main>
        <el-aside width="500px" :style="`padding-top:20px;padding-bottom:5px`">
          <div class="aside-container">
            <div class="data-item" style="margin-top: 50px">
              <span style="font-size: 25px; color: #0f0"
                >{{ $t("langcfg.txtPupilDiameter") }}: {{ dataInForm.pupildia.r }} mm</span
              >
              <!-- <el-form-item
                :label="`${$t('langcfg.txtPupilCenter')}:`"
                class="pupil-cornea-value"
              >
                <span style="font-size: 25px; color: #0f0"
                  >X: {{ dataInForm.pupildia.x }} mm</span
                >
              </el-form-item>
              <el-form-item :label="''" class="pupil-cornea-value">
                <span style="font-size: 25px; color: #0f0"
                  >Y: {{ dataInForm.pupildia.y }} mm</span
                >
              </el-form-item> -->
            </div>
            <div class="data-item">
              <span style="font-size: 25px; color: yellow"
                >{{ $t("langcfg.txtCorneaDiameter") }}: {{ dataInForm.corneadia.r }} mm</span
              >
              <!-- <el-form-item
                :label="`${$t('langcfg.txtCorneaCenter')}:`"
                class="pupil-cornea-value"
              >
                <span style="font-size: 25px; color: yellow"
                  >X: {{ dataInForm.corneadia.x }} mm</span
                >
              </el-form-item>
              <el-form-item :label="''" class="pupil-cornea-value">
                <span style="font-size: 25px; color: yellow"
                  >Y: {{ dataInForm.corneadia.y }} mm</span
                >
              </el-form-item> -->
            </div>
            <!-- <div class="data-item">
            <span style="font-size: 25px; color: white"
              >{{ $t('langcfg.txtPupilCorneaDist') }}:
              {{ dataInForm.dist }} mm</span
            >
          </div> -->
          </div>
        </el-aside>
      </el-container>
    </div>
    <div v-else>
      <el-container>
        <el-main :style="`height:${dispH - 58}px;width:62%`" v-if="selectVal === 'static'">
          <PupilCorneaStatic
            :dispW="dispW"
            :dispH="dispH"
            :graphMode="graphMode"
            :currentMode="currentMode"
            :currentEye="currentEye"
            :pupilStaticData="pupilStaticData"
            :corneaStaticData="corneaStaticData"
            :src="src"
            :coordinateSystem="coordinateSystem"
            @remove-pupil="removePupil"
          />
        </el-main>
        <el-main :style="`height:${dispH - 58}px;width:62%`" v-else>
          <PupilCorneaDynamic
            :currentRecord="record"
            :currentEye="currentEye"
            :currentMode="currentMode"
            :dispH="dispH"
            :dispW="dispW"
            :puilCorneaData="puilCorneaData"
            :pupilCalIndex="pupilCalIndex"
            :coordinateSystem="coordinateSystem"
          />
        </el-main>

        <el-aside :style="`padding-top:20px;padding-bottom:5px;width:38%;height:${dispH - 60}px`">
          <div class="select" style="width: 100%; height: 10%; margin-top: 20px">
            <el-select style="width: 90%" v-model="selectVal" @change="selectChange">
              <el-option
                v-for="(item, index) in selectOpt"
                :key="item.value"
                :label="selectLable[index]"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div style="width: 100%; height: 100%" v-if="selectVal === 'static'">
            <div
              class="aside-content0"
              style="width: 100%; height: 20%; display: flex; justify-content: center"
            >
              <div class="radioContainer" style="width: 85%; display: flex">
                <el-radio-group
                  v-model="pupilCorneaSelect"
                  text-color="#00ff00"
                  @change="pupilCorneaSelectChange"
                >
                  <el-radio label="pupil" text-color="#00ff00">{{
                    $t("langcfg.txtPupilDia")
                  }}</el-radio>
                  <el-radio label="cornea" text-color="#00ff00">{{
                    $t("langcfg.txtCorneaDiam")
                  }}</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="aside-content1"
              style="
                width: 100%;
                height: 30%;
                display: flex;
                flex-direction: column;
                align-items: center;
              "
            >
              <div class="title" style="font-size: 30px; color: #fff; width: 100%; height: 30%">
                {{ $t("langcfg.txtCorneaDiam") }} [mm]
              </div>
              <ul style="width: 90%; height: 70%; font-size: 22px">
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                    color: yellow;
                  "
                >
                  <p style="width: 33%; height: 100%; line-height: 50px">
                    {{ $t("langcfg.txtDiameter") }}
                  </p>
                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 66%; height: 100%; line-height: 50px"
                  >
                    Alpha(X mm, Y mm)
                  </p>

                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 66%; height: 100%; line-height: 50px"
                  >
                    Alpha(R @ θ)
                  </p>
                </li>
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                  "
                >
                  <p style="width: 33%; height: 100%; line-height: 50px">
                    <span v-show="pupilCorneaSelect !== 'pupil'">
                      <el-input-number
                        v-model="corneaCalData.diameter"
                        controls-position="right"
                        @change="staticCorneaChange"
                        @focus="handleCorneaChangeClick"
                        :min="0"
                        :max="20"
                        :step="0.01"
                        :precision="2"
                      ></el-input-number>
                      mm
                    </span>
                    <span v-show="pupilCorneaSelect === 'pupil'"
                      >{{ corneaCalData.diameter }} mm</span
                    >
                  </p>
                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 66%; height: 100%; line-height: 50px"
                  >
                    ({{ corneaCalData.offsetx }} mm, {{ corneaCalData.offsety }} mm)
                  </p>

                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 66%; height: 100%; line-height: 50px"
                  >
                    ({{ corneaCalData.offsetR }} mm @ {{ corneaCalData.offsetAngle }}°)
                  </p>
                </li>
              </ul>
            </div>
            <div
              class="aside-content2"
              style="
                width: 100%;
                height: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
              "
            >
              <div class="title" style="font-size: 30px; color: #fff; width: 100%; height: 15%">
                {{ $t("langcfg.txtPupilDia") }} [mm]
              </div>
              <ul style="width: 90%; height: 70%; font-size: 22px; margin-top: 20px">
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                    color: green;
                  "
                >
                  <p style="width: 30%; height: 100%; line-height: 50px">
                    {{ $t("langcfg.txtIlluminance") }}
                  </p>
                  <p style="width: 30%; height: 100%; line-height: 50px">
                    {{ $t("langcfg.txtDiameter") }}
                  </p>
                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    Kappa(X, Y)
                  </p>

                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    Kappa(R @ θ)
                  </p>
                </li>
                <li
                  v-for="(item, index) in puilCalStaticData"
                  :key="index"
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                  "
                >
                  <p style="width: 30%; height: 100%; line-height: 50px">
                    {{ getTitile(item.title) }}
                  </p>
                  <p
                    style="
                      width: 30%;
                      height: 100%;
                      line-height: 50px;
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                    "
                  >
                    <span v-show="!item.isDisabled">
                      <el-input-number
                        v-model="item.diameter"
                        controls-position="right"
                        @change="staticPuilChange(index)"
                        @focus="handleClick(index)"
                        :min="0"
                        :max="20"
                        :step="0.01"
                        :precision="2"
                      ></el-input-number>
                      mm
                    </span>
                    <span v-show="item.isDisabled">{{ item.diameter }} mm</span>
                  </p>

                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    ({{ item.offsetx }} mm, {{ item.offsety }} mm)
                  </p>

                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    ({{ item.offsetR }} mm @ {{ item.offsetAngle }}°)
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div v-else style="width: 100%; height: 100%">
            <div style="width: 100%; height: 30%"></div>
            <div
              class="aside-content2"
              style="
                width: 100%;
                height: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
              "
            >
              <div class="title" style="font-size: 30px; color: #fff; width: 100%; height: 15%">
                {{ $t("langcfg.txtPupilDia") }} [mm]
              </div>
              <ul style="width: 80%; height: 70%; font-size: 22px; margin-top: 20px">
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                    color: yellow;
                  "
                >
                  <p style="width: 40%; height: 100%; line-height: 50px">
                    {{ $t("langcfg.txtState") }}
                  </p>
                  <p style="width: 20%; height: 100%; line-height: 50px">
                    {{ $t("langcfg.txtDiameter") }}
                  </p>
                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 50%; height: 100%; line-height: 50px"
                  >
                    Kappa(X mm, Y mm)
                  </p>
                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    Kappa(R @ θ)
                  </p>
                </li>
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: solid gray 1px;
                    cursor: pointer;
                  "
                  v-for="(item, index) in puilCalData"
                  :key="index"
                  :class="{ 'pupilcal-highlight': index === pupilCalHighlightedIndex }"
                  @click="puilCalDataClick(item, index)"
                >
                  <p style="width: 40%; height: 100%; line-height: 50px">
                    {{ getStatus(item.status) }}
                  </p>
                  <p style="width: 20%; height: 100%; line-height: 50px">{{ item.diameter }} mm</p>
                  <p
                    v-if="coordinateSystem === 'rectangular'"
                    style="width: 50%; height: 100%; line-height: 50px"
                  >
                    ({{ item.offsetx }} mm, {{ item.offsety }} mm)
                  </p>
                  <p
                    v-if="coordinateSystem === 'polar'"
                    style="width: 40%; height: 100%; line-height: 50px"
                  >
                    ({{ item.offsetR }} mm @ {{ item.offsetAngle }}°)
                  </p>
                </li>
              </ul>

              <ul style="width: 80%; height: 30%; font-size: 22px; margin-top: 70px">
                <li
                  style="
                    width: 100%;
                    height: 50px;
                    display: flex;
                    border-bottom: solid gray 1px;
                    cursor: pointer;
                  "
                  v-for="(item, index) in puilT12"
                  :key="index"
                  :class="{ 'pupilt12-highlight': index === pupilt12HighlightedIndex }"
                  @click="puilT12Click(item, index)"
                >
                  <P
                    style="
                      width: 60%;
                      height: 100%;
                      line-height: 50px;
                      text-align: left;
                      padding-left: 20px;
                    "
                    >T({{ getT112Title(item.title) }})</P
                  >
                  <P
                    style="
                      width: 40%;
                      height: 100%;
                      line-height: 50px;
                      text-align: left;
                      padding-left: 20px;
                    "
                    >{{
                      item.startTimeIndex === 1000 || item.endTimeIndex === 1000
                        ? "--"
                        : ((item.endTimeIndex - item.startTimeIndex) * 0.1).toFixed(1)
                    }}
                    s</P
                  >
                  <!-- <p style="width: 5%; height: 100%; line-height: 50px; margin-left: -50px;"><i class="el-icon-warning" style="color:#999; cursor: pointer;"></i></p> -->
                </li>
              </ul>
            </div>
          </div>
        </el-aside>
      </el-container>
    </div>
  </div>
</template>
<script>
import { Size, SubPageSize, Message } from "../../mixins";
import ImageBox from "../../common/components/ImageBox";
import drawType from "../../common/components/drawType";
import Radio from "../../common/components/Radio";
import { isDataValid, isDefined } from "../shared";
import {
  hasKey,
  isEqual,
  logStdout,
  objectCopy,
  canConvertNumber,
  isNewPupilCorneadia
} from "../../shared/utils";
import { TOPOGRAPHYMODES } from "../../shared/consts";
import { Topography3rd } from "../js/thirdparty";
import EVENTS from "../../bus";
import VideoPlayer from "../../dryeye/components/basic/VideoPlayer.vue";
import PupilTrendChart from "./PupilTrendChart.vue";
import PupilCorneaStatic from "./PupilCorneaStatic.vue";
import PupilCorneaDynamic from "./PupilCorneaDynamic.vue";
import CalCase from "../js/CalCase.js";
import { mapGetters } from "vuex";

import * as record from "../../services/record";

const KEY = TOPOGRAPHYMODES.pupilcorneadia.key;
const DEFAULTEDGE = {
  x: -1000,
  y: -1000,
  r: -1000
};

const puilCorneaMockData = {
  resultPupilDiameter: [
    282.0099792480469, 283.4034118652344, 282.905029296875, 283.1324768066406, 282.0159606933594,
    280.2643737792969, 277.4101257324219, 277.940185546875, 279.7925720214844, 281.9051208496094,
    284.9008483886719, 285.67333984375, 253.11904907226562, 238.0406951904297, 216.56089782714844,
    202.7113037109375, 185.75454711914062, 180.2054443359375, 172.3415985107422, 167.97879028320312,
    159.69345092773438, 159.2533416748047, 161.0461883544922, 161.1637420654297, 162.246337890625,
    163.8619842529297, 165.53587341308594, 166.3963623046875, 165.76376342773438,
    164.19615173339844, 162.9359588623047, 164.04000854492188, 166.18287658691406, 168.75537109375,
    172.41302490234375, 171.94003295898438, 166.19642639160156, 163.25363159179688,
    160.79412841796875, 161.10865783691406, 161.2346954345703, 161.43380737304688,
    163.67115783691406, 165.03257751464844, 167.7583770751953, 168.0524444580078,
    166.41439819335938, 166.69696044921875, 169.73619079589844, 173.138671875, 178.89451599121094,
    181.8158416748047, 179.8235321044922, 177.11790466308594, 172.39199829101562,
    169.46754455566406, 168.4206085205078, 168.111572265625, 169.26162719726562, 171.04678344726562,
    174.0517120361328, 176.288818359375, 176.88131713867188, 176.4440460205078, 174.88568115234375,
    173.20652770996094, 172.0995330810547, 171.54190063476562, 170.73809814453125,
    169.73728942871094, 172.35646057128906, 180.07012939453125, 190.00131225585938,
    195.6885223388672, 201.44105529785156, -1000, 200.9869384765625, 213.70364379882812,
    218.07452392578125, 220.36447143554688, 222.84579467773438, 224.32008361816406,
    225.1627197265625, 227.03468322753906, 230.6442108154297, 232.1454315185547, 233.4453887939453,
    233.44432067871094, 234.99627685546875, 233.61666870117188, 231.6813507080078,
    229.85865783691406, 232.22779846191406, 235.99099731445312, 239.2624053955078,
    240.5109100341797, 241.2597198486328, 242.51133728027344, 243.55287170410156, 242.66952514648438
  ],
  resultPupilCenterX: [
    537.9125366210938, 538.3067626953125, 541.8902587890625, 542.8796997070312, 544.5086059570312,
    543.6421508789062, 540.3995971679688, 538.2625122070312, 532.8410034179688, 531.5372924804688,
    532.5380249023438, 532.2368774414062, 531.7056884765625, 530.836669921875, 528.3941650390625,
    531.547119140625, 533.8543090820312, 535.2232055664062, 535.9505615234375, 536.1279296875,
    536.3275756835938, 538.868896484375, 542.9762573242188, 541.4425659179688, 541.9055786132812,
    542.1209716796875, 542.9965209960938, 542.1809692382812, 542.92578125, 543.2860717773438,
    543.9322509765625, 544.0864868164062, 544.8543090820312, 544.6883544921875, 544.7930297851562,
    547.1500854492188, 548.1912841796875, 548.0552978515625, 545.9374389648438, 542.567138671875,
    546.240234375, 546.2826538085938, 545.2528686523438, 546.9673461914062, 552.8595581054688,
    549.98291015625, 550.975341796875, 558.7076416015625, 555.4613647460938, 557.7957763671875,
    559.1807861328125, 561.1229248046875, 560.9755859375, 562.8598022460938, 567.4668579101562,
    567.222900390625, 567.4901123046875, 565.8082885742188, 565.7903442382812, 565.4999389648438,
    563.5340576171875, 570.05322265625, 574.7919921875, 567.5315551757812, 562.1233520507812,
    560.3499755859375, 554.9487915039062, 556.9275512695312, 563.7291259765625, 564.5401611328125,
    563.2459716796875, 576.3474731445312, 576.6386108398438, 576.488525390625, 572.1311645507812,
    -1000, 563.168701171875, 564.8651733398438, 565.913330078125, 571.1570434570312,
    575.4631958007812, 575.6051635742188, 579.3392944335938, 570.71240234375, 571.120849609375,
    572.0543212890625, 582.8878784179688, 587.269775390625, 588.229736328125, 581.513671875,
    586.309814453125, 590.31689453125, 584.3446044921875, 581.4050903320312, 584.1776123046875,
    584.7199096679688, 583.4764404296875, 583.7648315429688, 580.0381469726562, 594.7540893554688
  ],
  resultPupilCenterY: [
    443.8591003417969, 444.57513427734375, 441.4957580566406, 442.1917724609375, 439.96466064453125,
    440.32037353515625, 440.0556640625, 439.61181640625, 442.6801452636719, 441.7042236328125,
    442.6635437011719, 442.6177673339844, 464.1393127441406, 453.4357604980469, 442.6902160644531,
    441.167236328125, 439.22564697265625, 436.42901611328125, 437.3747253417969, 439.25421142578125,
    445.54437255859375, 449.9845886230469, 448.825927734375, 448.6407775878906, 446.878173828125,
    446.37567138671875, 445.5694580078125, 445.936279296875, 447.2384033203125, 446.6294250488281,
    447.86236572265625, 447.7436828613281, 449.6443786621094, 451.6822509765625, 452.6837463378906,
    451.5146789550781, 453.3056945800781, 451.32470703125, 450.2587890625, 449.31976318359375,
    451.6435852050781, 458.1936950683594, 457.11126708984375, 456.1711120605469, 457.9118957519531,
    457.6094055175781, 462.2867431640625, 461.7934875488281, 457.84735107421875, 458.4247741699219,
    466.50030517578125, 469.200439453125, 472.291748046875, 476.1341857910156, 478.3291320800781,
    477.63995361328125, 480.05401611328125, 485.8186950683594, 487.4204406738281, 482.5077819824219,
    487.02960205078125, 485.1375427246094, 481.3785705566406, 469.6861572265625, 469.5575866699219,
    470.0604553222656, 470.71429443359375, 467.06134033203125, 468.11700439453125, 470.42236328125,
    469.9670715332031, 473.9234924316406, 476.44586181640625, 478.9524841308594, 480.6033630371094,
    -1000, 473.069091796875, 472.6493225097656, 482.9325256347656, 485.91455078125,
    484.7274169921875, 484.52947998046875, 490.3931884765625, 503.7381591796875, 503.8369445800781,
    507.69451904296875, 515.7543334960938, 523.9481811523438, 522.3795166015625, 520.37353515625,
    522.4484252929688, 522.8504028320312, 534.4085693359375, 534.8567504882812, 540.5888061523438,
    541.6358642578125, 543.428466796875, 538.6028442382812, 533.1873168945312, 528.445068359375
  ],
  ringCenterX: [
    539, 540, 542, 542, 543, 542, 539, 537, 535, 533, 535, 535, 526, 530, 533, 532, 534, 535, 536,
    537, 535, 534, 541, 540, 540, 540, 541, 540, 541, 542, 542, 542, -1000, 541, 542, 544, 546, 546,
    544, 543, 547, 548, 547, 548, 555, 552, 552, 557, 554, 557, 558, 560, 558, 561, 565, 564, 566,
    563, 563, 562, 560, 566, 572, 567, 562, 560, 555, 557, 563, 564, 562, 570, 571, 571, 566, -1000,
    559, 562, 562, 567, 570, 570, 573, 570, 570, 572, 581, 586, 587, 581, 586, 590, 584, 581, 585,
    586, 585, 585, 581, 591
  ],
  ringCenterY: [
    446, 447, 445, 446, 445, 445, 445, 444, 446, 447, 447, 447, 445, 445, 446, 446, 443, 441, 441,
    443, 444, 449, 452, 451, 450, 450, 449, 450, 451, 451, 451, 451, -1000, 455, 456, 455, 456, 454,
    454, 452, 456, 461, 460, 460, 461, 461, 465, 464, 461, 461, 469, 472, 476, 479, 482, 481, 483,
    489, 491, 485, 490, 488, 485, 478, 478, 479, 480, 476, 477, 479, 479, 480, 482, 484, 485, -1000,
    475, 482, 492, 495, 493, 492, 498, 509, 508, 511, 520, 527, 525, 523, 525, 526, 537, 538, 543,
    544, 545, 541, 536, 537
  ]
};

const puilCalMockData = [
  {
    status: "初始位置",
    diameter: "11.5",
    offsetx: "0.23",
    offsety: "0.23"
  },
  {
    status: "刺激开始位置",
    diameter: "11.5",
    offsetx: "0.23",
    offsety: "0.23"
  },
  {
    status: "最小瞳孔位置",
    diameter: "11.5",
    offsetx: "0.23",
    offsety: "0.23"
  },
  {
    status: "瞳孔恢复位置",
    diameter: "11.5",
    offsetx: "0.23",
    offsety: "0.23"
  }
];

const pupilT12MockData = [
  {
    title: "T1",
    startTimeIndex: 20,
    endTimeIndex: 21
  },
  {
    title: "T2",
    startTimeIndex: 21,
    endTimeIndex: 33
  }
];

const pupilStaticMockData = {
  cornea: {
    diameter: 510.5735778808594 * 2,
    centerX: 1004.0291137695312,
    centerY: 845.9063110351562,
    ringX: 1027.2806396484375,
    ringY: 812.9024658203125
  },
  pupil: [
    {
      title: "dark",
      diameter: 234.4453582763672 * 2,
      centerX: 1017.2806396484375,
      centerY: 812.9024658203125,
      ringX: 1027.2806396484375,
      ringY: 832.9024658203125
    },
    {
      title: "lowerMiddle",
      diameter: 234.4453582763672 * 2,
      centerX: 1017.2806396484375,
      centerY: 812.9024658203125,
      ringX: 1027.2806396484375,
      ringY: 832.9024658203125
    },
    {
      title: "middle",
      diameter: 234.4453582763672 * 2,
      centerX: 1017.2806396484375,
      centerY: 812.9024658203125,
      ringX: 1027.2806396484375,
      ringY: 832.9024658203125
    },
    {
      title: "bright",
      diameter: 234.4453582763672 * 2,
      centerX: 1017.2806396484375,
      centerY: 812.9024658203125,
      ringX: 1027.2806396484375,
      ringY: 832.9024658203125
    }
  ]
};

const corneaMockData = {
  diameter: 510.5735778808594 * 2,
  centerX: 1004.0291137695312,
  centerY: 845.9063110351562,
  ringX: 1027.2806396484375,
  ringY: 812.9024658203125
};

let timer = undefined;

export default {
  name: "PupilCornea",
  mixins: [Size, SubPageSize, Message],
  data() {
    return {
      isNewPupilCorneadia: false,
      coordinateSystem: "rectangular", // rectangular 代表直角坐标系, polar代表极坐标系
      currentCornea: "dark",
      pupilCorneaSelect: "pupil",
      puilCorneaData: puilCorneaMockData,
      pupilStaticData: pupilStaticMockData.pupil,
      corneaStaticData: pupilStaticMockData.cornea,
      largeImageIndex: 0,
      puilCalStaticData: [],
      puilCalData: [],
      corneaCalData: {},
      puilT12: [],
      pupilCalHighlightedIndex: 0,
      pupilt12HighlightedIndex: 0,
      pupilCalIndex: 0,
      selectOpt: [
        {
          value: "static",
          label: ""
        },
        {
          value: "dynamic",
          label: ""
        }
      ],
      selectVal: "static",
      zoom: 1.5,
      graphMode: "Select",
      drawTypeShow: true,
      currPage: "pupilcornea",
      data2Imgbox: {
        pupildia: {
          x: -1000,
          y: -1000,
          r: -1000
        },
        corneadia: {
          x: -1000,
          y: -1000,
          r: -1000
        }
      },
      dataOrg: {
        pupildia: {
          x: -1000,
          y: -1000,
          r: -1000
        },
        corneadia: {
          x: -1000,
          y: -1000,
          r: -1000
        }
      },
      dataInForm: {
        pupildia: {
          x: "--",
          y: "--",
          r: "--"
        },
        corneadia: {
          x: "--",
          y: "--",
          r: "--"
        },
        dist: "--"
      },
      darkVisionData: {
        pupildia: {
          x: "--",
          y: "--",
          r: "--"
        },
        corneadia: {
          x: "--",
          y: "--",
          r: "--"
        },
        dist: "--"
      },
      currentMode: "pupilcorneadia",
      currentOldMode: "pupilcorneadia",
      currentRecord: {},
      edgeMoved: objectCopy(DEFAULTEDGE),
      edge: objectCopy(DEFAULTEDGE),
      caculateTrendData: [],
      pupilChartState: false
    };
  },
  props: {
    pupilCorneaMode: {
      type: String,
      default: "corneadia"
    },
    currentPatient: {
      type: Object,
      default: () => {
        return {};
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    },
    currentPupilCornea: {
      type: String,
      default: ""
    }
  },
  watch: {
    graphMode: function (val) {
      this.resotreDia(val);
    },
    currentEye: function (val) {
      if (
        window.pupilCorneaMode &&
        hasKey(this.currentRecord, `content.data${this.currentEye}.${window.pupilCorneaMode}`)
      ) {
        this.currentMode = window.pupilCorneaMode;
      } else if (hasKey(this.currentRecord, `content.data${val}.pupilcorneadia`)) {
        this.currentMode = "pupilcorneadia";
      } else if (hasKey(this.currentRecord, `content.data${val}.scotopia`)) {
        this.currentMode = "scotopia";
      } else {
        this.currentMode = "dynamicpupil";
      }
      this.currentOldMode = this.currentMode;
      if (
        hasKey(this.currentRecord, `content.data${this.currentEye}.pupilcorneadia`) &&
        hasKey(this.currentRecord, `content.data${this.currentEye}.scotopia`)
      ) {
        this.initPupilCornea("scotopia");
        this.initPupilCornea("pupilcorneadia");
        this.initPupilCornea(this.currentMode);
      } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.pupilcorneadia`)) {
        this.initPupilCornea("pupilcorneadia");
      } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.scotopia`)) {
        this.initPupilCornea("scotopia");
      } else {
        this.initPupilCornea();
      }

      this.initSelectVal();
      this.$bus.$emit("CLOSELARGEIMAGE");
      // 初始化静态瞳孔数据
      this.initPupilStaticData();

      // 初始化动态瞳孔数据
      this.initPupilDynamicData();
      // 初始化角膜数据（如果暗视有数据，则用暗视的数据，没有则按顺序往后排）
      this.initCornea();

      this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);

      this.$bus.$emit("CHANGEIMAGEDATA", this.pupilStaticData);
      setTimeout(() => {
        this.$bus.$emit("PUPILXYCHANGE");
        this.$bus.$emit("PUPILCHARTCHANGE");
        this.$bus.$emit("PUPILVIDEOCHANGE");
        this.$bus.$emit("PUPILT1T2INDEX", this.puilT12[this.pupilt12HighlightedIndex]);
        this.$bus.$emit("PUPILCALINDEX", this.puilCalData[this.pupilCalHighlightedIndex].index);
      }, 100);
    }
  },
  created() {
    this.currentRecord = objectCopy(this.record);

    if (
      window.pupilCorneaMode &&
      hasKey(this.currentRecord, `content.data${this.currentEye}.${window.pupilCorneaMode}`)
    ) {
      this.currentMode = window.pupilCorneaMode;
    } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.pupilcorneadia`)) {
      this.currentMode = "pupilcorneadia";
      window.pupilCorneaMode = "pupilcorneadia";
    } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.scotopia`)) {
      this.currentMode = "scotopia";
      window.pupilCorneaMode = "scotopia";
    } else {
      this.currentMode = "dynamicpupil";
      window.pupilCorneaMode = "dynamicpupil";
    }
    if (
      hasKey(this.currentRecord, `content.data${this.currentEye}.pupilcorneadia`) &&
      hasKey(this.currentRecord, `content.data${this.currentEye}.scotopia`)
    ) {
      this.initPupilCornea("scotopia");
      this.initPupilCornea("pupilcorneadia");
      this.initPupilCornea(this.currentMode);
    } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.pupilcorneadia`)) {
      this.initPupilCornea("pupilcorneadia");
    } else if (hasKey(this.currentRecord, `content.data${this.currentEye}.scotopia`)) {
      this.initPupilCornea("scotopia");
    } else {
      this.initPupilCornea();
    }

    // 初始化静态瞳孔数据
    this.initPupilStaticData();

    // 初始化动态瞳孔数据
    this.initPupilDynamicData();
    // 初始化角膜数据（如果暗视有数据，则用暗视的数据，没有则按顺序往后排）
    this.initCornea();
    if (this.dataShowSettings && this.dataShowSettings.isCartesian === false) {
      // 极坐标系
      this.coordinateSystem = "polar";
    } else {
      // 直角坐标系
      this.coordinateSystem = "rectangular";
    }
  },
  mounted() {
    this.isNewPupilCorneadia = isNewPupilCorneadia(this.currentRecord, this.currentEye);
    this.initSelectVal();
    this.$emit("hide-waiting");
    this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
    if (this.puilT12.length > 0) {
      this.$bus.$emit("PUPILT1T2INDEX", this.puilT12[0]);
    }

    if (this.puilCalData.length > 0) {
      this.$bus.$emit("PUPILCALINDEX", this.puilCalData[this.pupilCalHighlightedIndex].index);
    }
    this.$bus.$on("PUPILT1T2INDEXF", () => {
      this.$bus.$emit("PUPILT1T2INDEX", this.puilT12[this.pupilt12HighlightedIndex]);
      this.$bus.$emit("PUPILCALINDEX", this.puilCalData[this.pupilCalHighlightedIndex].index);
    });

    this.$bus.$on("LARGEIMAGE", (status, index) => {
      this.largeImageIndex = index;
      if (status === "open") {
        this.puilCalStaticData[index]["isDisabled"] = false;
      } else if (status === "close") {
        this.puilCalStaticData[index]["isDisabled"] = true;
      } else {
        this.puilCalStaticData.forEach((item) => {
          item["isDisabled"] = true;
        });
      }
    });

    this.$bus.$on("CHANGECOORDINATESYSTEM", (isCartesian) => {
      this.coordinateSystem = isCartesian ? "rectangular" : "polar";
    });

    this.$bus.$on("RESETPUPILCORNEA", (pupilOrCornea, title) => {
      this.resetpupilcornea(pupilOrCornea, title);
    });
  },
  destroyed() {
    this.$bus.$off("PUPILT1T2INDEXF");
    this.$bus.$off("LARGEIMAGE");
    this.$bus.$off("CHANGECOORDINATESYSTEM");
    this.$bus.$off("RESETPUPILCORNEA");
  },
  components: {
    ImageBox,
    drawType,
    Radio,
    VideoPlayer,
    PupilTrendChart,
    PupilCorneaStatic,
    PupilCorneaDynamic
  },
  methods: {
    removePupil(item, index) {
      this.confirm(
        this.$t("langcfg.txtDelPupilData", { title: this.getTitile(item.title) }),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          if (
            this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${item.title}`]
          ) {
            delete this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${item.title}`
            ];
            record.updateRecord(this.currentRecord, (res) => {
              if (res.message === "OK") {
                this.$bus.$emit("CHANGECURRENTRECORD", this.currentRecord);
              }
            });
            this.initPupilStaticData();
            this.initSelectVal();
            this.initCornea();
            this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
            this.$bus.$emit("CHANGEIMAGEDATA", this.pupilStaticData);
          }
        })
        .catch(() => {});
    },
    initSelectVal() {
      if (window.pupilCorneaSelect) {
        if (
          this.currentRecord.content[`data${this.currentEye}`] &&
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${window.pupilCorneaSelect}`
          ]
        ) {
          this.selectVal = window.pupilCorneaSelect;
        } else {
          if (
            this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"] ||
            this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"] ||
            this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"] ||
            this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]
          ) {
            this.selectVal = "static";
          } else if (
            this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]
          ) {
            this.selectVal = "dynamic";
          }
        }
        return;
      }
      if (
        this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"] ||
        this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"] ||
        this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"] ||
        this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]
      ) {
        this.selectVal = "static";
      } else if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]) {
        this.selectVal = "dynamic";
      } else {
        if (this.isNewPupilCorneadia) {
          if (
            this.currentRecord.content.dataOD.topography ||
            this.currentRecord.content.dataOS.topography ||
            this.currentRecord.content.dataOD.pupilcorneadia_dark ||
            this.currentRecord.content.dataOS.pupilcorneadia_dark ||
            this.currentRecord.content.dataOD.pupilcorneadia ||
            this.currentRecord.content.dataOS.pupilcorneadia ||
            this.currentRecord.content.dataOD.pupilcorneadia_lowerMiddle ||
            this.currentRecord.content.dataOS.pupilcorneadia_lowerMiddle ||
            this.currentRecord.content.dataOD.pupilcorneadia_middle ||
            this.currentRecord.content.dataOS.pupilcorneadia_middle ||
            this.currentRecord.content.dataOD.pupilcorneadia_bright ||
            this.currentRecord.content.dataOS.pupilcorneadia_bright ||
            this.currentRecord.content.dataOD.pupilcorneadia_dynamic ||
            this.currentRecord.content.dataOS.pupilcorneadia_dynamic
          ) {
          } else {
            record.deleteRecord(this.currentRecord._id, this.currentRecord, (res) => {
              console.log("---hidePupilCorneaPreview--- record.deleteRecord res", res);
              this.$bus.$emit("CHANGECURRENTRECORD", null);
              this.$bus.$emit("BACKTOPATIRNT");
            });
          }
        }
      }
    },
    initPupilStaticData() {
      this.pupilStaticData = [];
      const { serverip, serverport, sslport, serverssl } = window.server || {};
      let protocol = serverssl === 1 ? "https:" : "http:";
      let port = serverssl === 1 ? sslport : serverport;
      // return isDefined(photo) ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}` : ''
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"]
        );
        this.pupilStaticData.push({
          title: "dark",
          diameter: data.pupildia.edge.r,
          centerX: data.pupildia.edge.x,
          centerY: data.pupildia.edge.y,
          ringX: data.pupildia.edge.rx,
          ringY: data.pupildia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        });
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"]
        );
        this.pupilStaticData.push({
          title: "lowerMiddle",
          diameter: data.pupildia.edge.r,
          centerX: data.pupildia.edge.x,
          centerY: data.pupildia.edge.y,
          ringX: data.pupildia.edge.rx,
          ringY: data.pupildia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        });
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"]
        );
        this.pupilStaticData.push({
          title: "middle",
          diameter: data.pupildia.edge.r,
          centerX: data.pupildia.edge.x,
          centerY: data.pupildia.edge.y,
          ringX: data.pupildia.edge.rx,
          ringY: data.pupildia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        });
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]
        );
        this.pupilStaticData.push({
          title: "bright",
          diameter: data.pupildia.edge.r,
          centerX: data.pupildia.edge.x,
          centerY: data.pupildia.edge.y,
          ringX: data.pupildia.edge.rx,
          ringY: data.pupildia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        });
      }
    },
    initCornea() {
      this.corneaStaticData = {};
      const { serverip, serverport, sslport, serverssl } = window.server || {};
      let protocol = serverssl === 1 ? "https:" : "http:";
      let port = serverssl === 1 ? sslport : serverport;
      // return isDefined(photo) ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}` : ''
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"]
        );
        this.corneaStaticData = {
          diameter: data.corneadia.edge.r,
          centerX: data.corneadia.edge.x,
          centerY: data.corneadia.edge.y,
          ringX: data.corneadia.edge.rx,
          ringY: data.corneadia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        };
        this.currentCornea = "dark";
        return;
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"]
        );
        this.corneaStaticData = {
          diameter: data.corneadia.edge.r,
          centerX: data.corneadia.edge.x,
          centerY: data.corneadia.edge.y,
          ringX: data.corneadia.edge.rx,
          ringY: data.corneadia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        };
        this.currentCornea = "lowerMiddle";
        return;
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"]
        );
        this.corneaStaticData = {
          diameter: data.corneadia.edge.r,
          centerX: data.corneadia.edge.x,
          centerY: data.corneadia.edge.y,
          ringX: data.corneadia.edge.rx,
          ringY: data.corneadia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        };
        this.currentCornea = "middle";
        return;
      }
      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]
        );
        this.corneaStaticData = {
          diameter: data.corneadia.edge.r,
          centerX: data.corneadia.edge.x,
          centerY: data.corneadia.edge.y,
          ringX: data.corneadia.edge.rx,
          ringY: data.corneadia.edge.ry,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        };
        this.currentCornea = "bright";
        return;
      }
    },
    initPupilDynamicData() {
      this.puilCorneaData = {};
      const { serverip, serverport, sslport, serverssl } = window.server || {};
      let protocol = serverssl === 1 ? "https:" : "http:";
      let port = serverssl === 1 ? sslport : serverport;

      if (this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]) {
        const data = objectCopy(
          this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]
        );
        this.puilCorneaData = {
          resultPupilDiameter: data.pupilArray.resultPupilDiameter,
          resultPupilCenterX: data.pupilArray.resultPupilCenterX,
          resultPupilCenterY: data.pupilArray.resultPupilCenterY,
          ringCenterX: data.pupilArray.ringCenterX,
          ringCenterY: data.pupilArray.ringCenterY,
          media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        };
      }
    },
    resetpupilcornea(pupilOrCornea, title) {
      if (pupilOrCornea === "pupil") {
        // 重置瞳孔数据
        if (
          this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${title}_origin`]
        ) {
          this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${title}`][
            "pupildia"
          ] = objectCopy(
            this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${title}_origin`][
              "pupildia"
            ]
          );
          record.updateRecord(this.currentRecord, (res) => {
            if (res.message === "OK") {
              this.$bus.$emit("CHANGECURRENTRECORD", this.currentRecord);
            }
          });
          this.initPupilStaticData();
          const pupil =
            this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${title}`][
              "pupildia"
            ];
          const data = {
            corneadia: {
              r: 0,
              x: 0,
              y: 0
            },
            pupildia: {
              r: pupil.edge.r,
              x: pupil.edge.x,
              y: pupil.edge.y,
              rx: pupil.edge.rx,
              ry: pupil.edge.ry
            }
          };
          this.$bus.$emit("REDRAW", data);
          this.$bus.$emit("CHANGEIMAGEDATA", this.pupilStaticData);
          this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
          this.puilCalStaticData[this.largeImageIndex]["isDisabled"] = false;
        } else {
          const pupil =
            this.currentRecord.content[`data${this.currentEye}`][`pupilcorneadia_${title}`][
              "pupildia"
            ];
          const data = {
            corneadia: {
              r: 0,
              x: 0,
              y: 0
            },
            pupildia: {
              r: pupil.edge.r,
              x: pupil.edge.x,
              y: pupil.edge.y,
              rx: pupil.edge.rx,
              ry: pupil.edge.ry
            }
          };
          this.$bus.$emit("REDRAW", data);
          this.$bus.$emit("CHANGEIMAGEDATA", this.pupilStaticData);
          this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
          this.puilCalStaticData[this.largeImageIndex]["isDisabled"] = false;
        }
      } else {
        // 重置角膜数据
        if (
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.currentCornea}_origin`
          ]
        ) {
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.currentCornea}`
          ]["corneadia"] = objectCopy(
            this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.currentCornea}_origin`
            ]["corneadia"]
          );
          record.updateRecord(this.currentRecord, (res) => {
            if (res.message === "OK") {
              this.$bus.$emit("CHANGECURRENTRECORD", this.currentRecord);
            }
          });
          this.initCornea();
          this.$bus.$emit(
            "CHANGECORNEADATA",
            this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.currentCornea}`
            ]["corneadia"]["edge"].r
          );
          this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
        } else {
          this.initCornea();
          this.$bus.$emit(
            "CHANGECORNEADATA",
            this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.currentCornea}`
            ]["corneadia"]["edge"].r
          );
          this.puilCalDataMed(this.puilCorneaData, this.pupilStaticData);
        }
      }
    },
    staticCorneaChange(val) {
      if (this.corneaCalData.diameter >= 20) {
        this.corneaCalData.diameter = 20;
      }
      const pixs = this.corneaCalData.diameter / (window.magecoe.pupilcornea * 2);
      this.$bus.$emit("CHANGECORNEADATA", pixs);

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.currentCornea}`
          ]
        ) {
          if (
            !this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.currentCornea}_origin`
            ]
          ) {
            this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.currentCornea}_origin`
            ] = objectCopy(
              this.currentRecord.content[`data${this.currentEye}`][
                `pupilcorneadia_${this.currentCornea}`
              ]
            );
          }
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.currentCornea}`
          ]["corneadia"]["edge"].r = pixs;
          record.updateRecord(this.currentRecord, (res) => {
            if (res.message === "OK") {
              this.$bus.$emit("CHANGECURRENTRECORD", this.currentRecord);
            }
            timer = undefined;
          });
        }
      }, 1000);
    },
    handleCorneaChangeClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.corneaCalData.diameter.toString(), (value) => {
        if (canConvertNumber(value)) {
          if (value >= 20) {
            value = 20;
          }
          self.corneaCalData.diameter = Number(value);
          self.staticCorneaChange();
        }
      });
    },
    pupilCorneaSelectChange(val) {
      this.$bus.$emit("PUPILCORNEASELECTCHANGE", val);
      if (val === "pupil") {
        this.$bus.$emit("LARGEIMAGE", "clsoe", this.largeImageIndex);
        this.$bus.$emit("CLOSELARGEIMAGE");
      } else {
        this.$bus.$emit("LARGEIMAGE", "clsoe", this.largeImageIndex);
      }
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(
        EVENTS.spreadKeyBoard,
        self.puilCalStaticData[key].diameter.toString(),
        (value) => {
          if (canConvertNumber(value)) {
            if (value >= 20) {
              value = 20;
            }
            self.puilCalStaticData[key].diameter = Number(value);
            self.staticPuilChange(key);
          }
        }
      );
    },
    staticPuilChange(index) {
      if (this.puilCalStaticData[index].diameter >= 20) {
        this.puilCalStaticData[index].diameter = 20;
      }
      const pixs = this.puilCalStaticData[index].diameter / (window.magecoe.pupilcornea * 2);
      const data = {
        corneadia: {
          r: 0,
          x: 0,
          y: 0
        },
        pupildia: {
          r: pixs,
          x: this.pupilStaticData[index].centerX,
          y: this.pupilStaticData[index].centerY,
          rx: this.pupilStaticData[index].ringX,
          ry: this.pupilStaticData[index].ringY
        }
      };
      this.pupilStaticData[index].diameter = pixs;

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.pupilStaticData[index].title}`
          ]
        ) {
          if (
            !this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.pupilStaticData[index].title}_origin`
            ]
          ) {
            this.currentRecord.content[`data${this.currentEye}`][
              `pupilcorneadia_${this.pupilStaticData[index].title}_origin`
            ] = objectCopy(
              this.currentRecord.content[`data${this.currentEye}`][
                `pupilcorneadia_${this.pupilStaticData[index].title}`
              ]
            );
          }
          this.currentRecord.content[`data${this.currentEye}`][
            `pupilcorneadia_${this.pupilStaticData[index].title}`
          ]["pupildia"]["edge"].r = pixs;
          record.updateRecord(this.currentRecord, (res) => {
            if (res.message === "OK") {
              this.$bus.$emit("CHANGECURRENTRECORD", this.currentRecord);
            }
            timer = undefined;
          });
        }
      }, 1000);

      this.$bus.$emit("REDRAW", data);
      this.$bus.$emit("CHANGEIMAGEDATA", this.pupilStaticData);
    },
    selectChange(val) {
      window.pupilCorneaSelect = val;
      if (val === "dynamic") {
        if (!this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]) {
          this.$emit("show-capture", "pupilcorneadia");
        }
        // this.$bus.$emit('PUPILT1T2INDEX', this.puilT12[0])
      } else {
        // this.$bus.$emit("PAUSEVIDEO");
        this.pupilCorneaSelect = "pupil";
        // this.$bus.$emit('PUPILCORNEASELECTCHANGE', this.pupilCorneaSelect)
        if (
          !this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_dark"] &&
          !this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"] &&
          !this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_middle"] &&
          !this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia_bright"]
        ) {
          this.$emit("show-capture", "pupilcorneadia");
        }
      }
    },
    puilCalDataClick(item, index) {
      this.pupilCalHighlightedIndex = index;

      this.$bus.$emit("PUPILCALINDEX", item.index);
    },
    puilT12Click(item, index) {
      this.pupilt12HighlightedIndex = index;
      this.$bus.$emit("PUPILT1T2INDEX", item);
    },
    findMinExcluding(arr, excludeValue) {
      // const filteredArray = arr.map((value, index) => ({ value, index })).filter(item => item.value !== excludeValue);
      let minValue = -excludeValue;
      let minIndex = -excludeValue;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== excludeValue && arr[i] < minValue) {
          minValue = arr[i];
          minIndex = i;
        }
      }
      return { minValue, minIndex };
    },
    cartesianToPolar(x, y) {
      if (x === "--" || y === "--" || x === -1000 || y === -1000) {
        return {
          radius: "--",
          angle: "--", // 弧度
          angleDegrees: "--" // 度数
        };
      }
      // 计算半径 R
      const radius = Math.sqrt(x * x + y * y);
      // 计算角度 θ（弧度）
      let angle = Math.atan2(y, x);

      if (angle < 0) {
        angle += 2 * Math.PI;
      }

      // 如果需要角度（度数）
      const angleDegrees = angle * (180 / Math.PI);
      // 返回极坐标（半径和角度）
      return {
        radius: radius.toFixed(2),
        angle: angle, // 弧度
        angleDegrees: angleDegrees.toFixed(0) // 度数
      };
    },
    findIndicesAfterValue(arr, value) {
      if (value === -1000) {
        return 1000;
      }
      for (let i = 40; i < arr.length; i++) {
        if (arr[i] >= value) {
          return i;
        }
      }
      let maxValue = 0;
      let maxIndex = 0;
      for (let i = 40; i < arr.length; i++) {
        if (arr[i] !== -1000 && arr[i] > maxValue) {
          maxValue = arr[i];
          maxIndex = i;
        }
      }
      return maxIndex;
    },
    calT(arr) {
      let minValue = 1000;
      let minIndex = 1000;
      for (let i = 20; i <= 40; i++) {
        if (arr[i] !== -1000 && arr[i] < minValue) {
          minValue = arr[i];
          minIndex = i;
        }
      }
      return {
        minValue,
        minIndex
      };
    },
    puilCalDataMed(puilCorneaData, pupilStaticData) {
      if (puilCorneaData.resultPupilDiameter) {
        // 计算初始位置
        this.puilCalData = [];
        this.puilT12 = [];
        const beginDiameter =
          puilCorneaData.resultPupilDiameter[0] === -1000
            ? "--"
            : (puilCorneaData.resultPupilDiameter[0] * 2 * window.magecoe.pupilcornea).toFixed(2);
        const beginOffsetx =
          puilCorneaData.resultPupilCenterX[0] === -1000 || puilCorneaData.ringCenterX[0] === -1000
            ? "--"
            : (
                (puilCorneaData.resultPupilCenterX[0] - puilCorneaData.ringCenterX[0]) *
                2 *
                window.magecoe.pupilcornea
              ).toFixed(2);
        const beginOffsety =
          puilCorneaData.resultPupilCenterY[0] === -1000 || puilCorneaData.ringCenterY[0] === -1000
            ? "--"
            : (
                (puilCorneaData.resultPupilCenterY[0] - puilCorneaData.ringCenterY[0]) *
                2 *
                window.magecoe.pupilcornea
              ).toFixed(2);

        this.puilCalData.push({
          status: "start",
          diameter: beginDiameter,
          offsetx: beginOffsetx,
          offsety: beginOffsety,
          index: 0,
          offsetR: this.cartesianToPolar(beginOffsetx, beginOffsety).radius,
          offsetAngle: this.cartesianToPolar(beginOffsetx, beginOffsety).angleDegrees
        });

        // 计算刺激开始位置
        const irritateDiameter =
          puilCorneaData.resultPupilDiameter[20] === -1000
            ? "--"
            : (puilCorneaData.resultPupilDiameter[20] * 2 * window.magecoe.pupilcornea).toFixed(2);
        const irritateOffsetx =
          puilCorneaData.resultPupilCenterX[20] === -1000 ||
          puilCorneaData.ringCenterX[20] === -1000
            ? "--"
            : (
                (puilCorneaData.resultPupilCenterX[20] - puilCorneaData.ringCenterX[20]) *
                2 *
                window.magecoe.pupilcornea
              ).toFixed(2);
        const irritateOffsety =
          puilCorneaData.resultPupilCenterY[20] === -1000 ||
          puilCorneaData.ringCenterY[20] === -1000
            ? "--"
            : (
                (puilCorneaData.resultPupilCenterY[20] - puilCorneaData.ringCenterY[20]) *
                2 *
                window.magecoe.pupilcornea
              ).toFixed(2);
        this.puilCalData.push({
          status: "irritate",
          diameter: irritateDiameter,
          offsetx: irritateOffsetx,
          offsety: irritateOffsety,
          index: 20,
          offsetR: this.cartesianToPolar(irritateOffsetx, irritateOffsety).radius,
          offsetAngle: this.cartesianToPolar(irritateOffsetx, irritateOffsety).angleDegrees
        });

        // 计算最小瞳孔位置
        const minDiameterInfo = this.findMinExcluding(puilCorneaData.resultPupilDiameter, -1000);

        const minDiameter =
          minDiameterInfo.minValue === 1000
            ? "--"
            : (minDiameterInfo.minValue * 2 * window.magecoe.pupilcornea).toFixed(2);
        const minOffsetx =
          minDiameterInfo.minIndex === 1000
            ? "--"
            : puilCorneaData.resultPupilCenterX[minDiameterInfo.minIndex] === -1000 ||
                puilCorneaData.ringCenterX[minDiameterInfo.minIndex] === -1000
              ? "--"
              : (
                  (puilCorneaData.resultPupilCenterX[minDiameterInfo.minIndex] -
                    puilCorneaData.ringCenterX[minDiameterInfo.minIndex]) *
                  2 *
                  window.magecoe.pupilcornea
                ).toFixed(2);
        const minOffsety =
          minDiameterInfo.minIndex === 1000
            ? "--"
            : puilCorneaData.resultPupilCenterY[minDiameterInfo.minIndex] === -1000 ||
                puilCorneaData.ringCenterY[minDiameterInfo.minIndex] === -1000
              ? "--"
              : (
                  (puilCorneaData.resultPupilCenterY[minDiameterInfo.minIndex] -
                    puilCorneaData.ringCenterY[minDiameterInfo.minIndex]) *
                  2 *
                  window.magecoe.pupilcornea
                ).toFixed(2);
        this.puilCalData.push({
          status: "min",
          diameter: minDiameter,
          offsetx: minOffsetx,
          offsety: minOffsety,
          index: minDiameterInfo.minIndex,
          offsetR: this.cartesianToPolar(minOffsetx, minOffsety).radius,
          offsetAngle: this.cartesianToPolar(minOffsetx, minOffsety).angleDegrees
        });
        // 计算瞳孔恢复位置
        const recoverDiameterIndex = this.findIndicesAfterValue(
          puilCorneaData.resultPupilDiameter,
          puilCorneaData.resultPupilDiameter[20]
        );
        const recoverDiameter =
          recoverDiameterIndex === 1000
            ? "--"
            : puilCorneaData.resultPupilDiameter[recoverDiameterIndex] === -1000
              ? "--"
              : (
                  puilCorneaData.resultPupilDiameter[recoverDiameterIndex] *
                  2 *
                  window.magecoe.pupilcornea
                ).toFixed(2);
        const recoverOffsetx =
          recoverDiameterIndex === 1000
            ? "--"
            : puilCorneaData.resultPupilCenterX[recoverDiameterIndex] === -1000 ||
                puilCorneaData.ringCenterX[recoverDiameterIndex] === -1000
              ? "--"
              : (
                  (puilCorneaData.resultPupilCenterX[recoverDiameterIndex] -
                    puilCorneaData.ringCenterX[recoverDiameterIndex]) *
                  2 *
                  window.magecoe.pupilcornea
                ).toFixed(2);
        const recoverOffsety =
          recoverDiameterIndex === 1000
            ? "--"
            : puilCorneaData.resultPupilCenterY[recoverDiameterIndex] === -1000 ||
                puilCorneaData.ringCenterY[recoverDiameterIndex] === -1000
              ? "--"
              : (
                  (puilCorneaData.resultPupilCenterY[recoverDiameterIndex] -
                    puilCorneaData.ringCenterY[recoverDiameterIndex]) *
                  2 *
                  window.magecoe.pupilcornea
                ).toFixed(2);
        this.puilCalData.push({
          status: "recover",
          diameter: recoverDiameter,
          offsetx: recoverOffsetx,
          offsety: recoverOffsety,
          index: recoverDiameterIndex,
          offsetR: this.cartesianToPolar(recoverOffsetx, recoverOffsety).radius,
          offsetAngle: this.cartesianToPolar(recoverOffsetx, recoverOffsety).angleDegrees
        });

        // 计算T1
        this.puilT12.push({
          title: "T1",
          startTimeIndex: 20,
          endTimeIndex: this.calT(puilCorneaData.resultPupilDiameter).minIndex
        });

        // 计算T2
        this.puilT12.push({ title: "T2", startTimeIndex: 40, endTimeIndex: recoverDiameterIndex });
      }

      // 计算不同灯光亮度对应的瞳孔直径
      this.puilCalStaticData = pupilStaticData.map((item) => {
        let offsetx =
          item.centerX === -1000 || item.ringX === -1000
            ? "--"
            : ((item.centerX - item.ringX) * window.magecoe.pupilcornea * 2).toFixed(2);
        let offsety =
          item.centerY === -1000 || item.ringY === -1000
            ? "--"
            : ((item.centerY - item.ringY) * window.magecoe.pupilcornea * 2).toFixed(2);
        return {
          id: item.title,
          title: item.title,
          diameter:
            item.diameter === -1000
              ? "--"
              : item.diameter * window.magecoe.pupilcornea * 2 > 20
                ? "20.00"
                : (item.diameter * window.magecoe.pupilcornea * 2).toFixed(2),
          offsetx: offsetx,
          offsety: offsety,
          offsetR: this.cartesianToPolar(offsetx, offsety).radius,
          offsetAngle: this.cartesianToPolar(offsetx, offsety).angleDegrees,
          isDisabled: true
        };
      });
      // 计算角膜直径
      this.corneaCalData = {
        diameter:
          this.corneaStaticData.diameter === -1000
            ? "--"
            : this.corneaStaticData.diameter * window.magecoe.pupilcornea * 2 > 20
              ? "20.00"
              : (this.corneaStaticData.diameter * window.magecoe.pupilcornea * 2).toFixed(2),
        offsetx:
          this.corneaStaticData.centerX === -1000 || this.corneaStaticData.ringX === -1000
            ? "--"
            : (
                (this.corneaStaticData.centerX - this.corneaStaticData.ringX) *
                window.magecoe.pupilcornea *
                2
              ).toFixed(2),
        offsety:
          this.corneaStaticData.centerY === -1000 || this.corneaStaticData.ringY === -1000
            ? "--"
            : (
                (this.corneaStaticData.centerY - this.corneaStaticData.ringY) *
                window.magecoe.pupilcornea *
                2
              ).toFixed(2)
        // offsetR: this.cartesianToPolar(this.corneaStaticData.centerX, this.corneaStaticData.centerY).radius,
        // offsetAngle: this.cartesianToPolar(this.corneaStaticData.centerX, this.corneaStaticData.centerY).angleDegrees
      };
      this.corneaCalData["offsetR"] = this.cartesianToPolar(
        this.corneaCalData.offsetx,
        this.corneaCalData.offsety
      ).radius;
      this.corneaCalData["offsetAngle"] = this.cartesianToPolar(
        this.corneaCalData.offsetx,
        this.corneaCalData.offsety
      ).angleDegrees;
    },
    getT112Title(title) {
      if (title === "T1") {
        return this.$t("langcfg.txtShrinkTime");
      } else {
        return this.$t("langcfg.txtRecoverTime");
      }
    },
    getStatus(status) {
      if (status === "start") {
        return this.$t("langcfg.txtStartLight");
      } else if (status === "irritate") {
        return this.$t("langcfg.txtStartRrritate");
      } else if (status === "min") {
        return this.$t("langcfg.txtMinPupil");
      } else {
        return this.$t("langcfg.txtPupilRecover");
      }
    },
    getTitile(title) {
      switch (title) {
        case "dark":
          return this.$t("langcfg.txtpupilcorneaDark");
        case "lowerMiddle":
          return this.$t("langcfg.txtpupilcorneaLowerMiddle");
        case "middle":
          return this.$t("langcfg.txtpupilcorneaMiddle");
        case "bright":
          return this.$t("langcfg.txtpupilcorneaBright");
        default:
          return this.$t("langcfg.txtpupilcorneaDark");
      }
    },
    testPupil() {
      let test = CalCase.findPupilCorneaVideo();
    },
    update() {
      if (hasKey(this.currentRecord, `content.data${this.currentEye}.${this.currentMode}`)) {
        if (
          this.isEdgeChanged("corneadia", this.dataOrg.corneadia) ||
          this.isEdgeChanged("pupildia", this.dataOrg.pupildia)
        ) {
          this.currentRecord.content[`data${this.currentEye}`][
            this.currentMode
          ].pupildia.edgeMoved = objectCopy(this.dataOrg.pupildia);
          this.currentRecord.content[`data${this.currentEye}`][
            this.currentMode
          ].corneadia.edgeMoved = objectCopy(this.dataOrg.corneadia);
          this.data2Imgbox = objectCopy(this.dataOrg);
          this.calcDist(this.dataOrg.pupildia, this.dataOrg.corneadia);
          this.currentRecord.content[`data${this.currentEye}`][this.currentMode].uploaded = false;
          logStdout("update record before update pupil cornea");
          this.$emit("update-record", this.currentRecord, (res) => {
            logStdout("update record after update pupil cornea res", res);
            if (res.message !== "OK") {
              this.notify(this.$t("langcfg.txtUpdateDataFailed"), "", "error");
            } else {
            }
          });
          this.uploadThirdParty();
        }
      }
    },
    calcDist(pupil, cornea) {
      try {
        if (isDefined(pupil) && isDefined(cornea)) {
          this.dataInForm.dist = (
            Math.sqrt(Math.pow(pupil.x - cornea.x, 2) + Math.pow(pupil.y - cornea.y, 2)) *
            window.magecoe.pupilcornea
          )._toFixed(2);
        } else {
          this.dataInForm.dist = "--";
        }
      } catch (e) {
        this.dataInForm.dist = "--";
      }
    },
    onEdgeChanged(mode, edge) {
      this.initEdge(mode, edge, this.currentMode);
    },
    initEdge(mode, edge, type = "") {
      let coe = window.magecoe.pupilcornea;
      this.dataOrg[mode].r = edge.r;
      this.dataOrg[mode].x = edge.x;
      this.dataOrg[mode].y = edge.y;
      let _mode = mode === "corneadia" ? "pupildia" : "corneadia";
      this.calcDist(this.dataOrg[mode], this.dataOrg[_mode]);
      if (isDefined(edge) && isDataValid(edge.r) && edge.r > 0) {
        if (type === "scotopia") {
          this.darkVisionData[mode].r = (edge.r * 2 * coe)._toFixed(2);
          this.darkVisionData[mode].x = (edge.x * coe)._toFixed(2);
          this.darkVisionData[mode].y = (edge.y * coe)._toFixed(2);
        } else {
          this.dataInForm[mode].r = (edge.r * 2 * coe)._toFixed(2);
          this.dataInForm[mode].x = (edge.x * coe)._toFixed(2);
          this.dataInForm[mode].y = (edge.y * coe)._toFixed(2);
        }
      } else {
        if (type === "scotopia") {
          this.darkVisionData[mode].r = "--";
          this.darkVisionData[mode].x = "--";
          this.darkVisionData[mode].y = "--";
        } else {
          this.dataInForm[mode].r = "--";
          this.dataInForm[mode].x = "--";
          this.dataInForm[mode].y = "--";
        }
      }
    },

    initPupilCornea(mode) {
      let state = true;
      let edgePupil, edgeCornea;

      if (
        hasKey(
          this.currentRecord,
          `content.data${this.currentEye}.${mode ? mode : this.currentMode}.pupildia`
        )
      ) {
        let pupildia =
          this.currentRecord.content[`data${this.currentEye}`][mode ? mode : this.currentMode][
            "pupildia"
          ];
        if (isDefined(pupildia.edge) && isDataValid(pupildia.edge.r) && pupildia.edge.r > 0) {
          let edgeMoved = pupildia.edgeMoved;
          let edge =
            isDefined(edgeMoved) && isDataValid(edgeMoved.r) && edgeMoved.r > 0
              ? edgeMoved
              : pupildia.edge;
          edgePupil = edge;
          this.initEdge("pupildia", edge, mode ? mode : this.currentMode);
        } else {
          state = false;
        }
      } else {
        state = false;
      }
      if (
        hasKey(
          this.currentRecord,
          `content.data${this.currentEye}.${mode ? mode : this.currentMode}.corneadia`
        )
      ) {
        let corneadia =
          this.currentRecord.content[`data${this.currentEye}`][mode ? mode : this.currentMode][
            "corneadia"
          ];
        if (isDefined(corneadia.edge) && isDataValid(corneadia.edge.r) && corneadia.edge.r > 0) {
          let edgeMoved = corneadia.edgeMoved;
          let edge =
            isDefined(edgeMoved) && isDataValid(edgeMoved.r) && edgeMoved.r > 0
              ? edgeMoved
              : corneadia.edge;
          edgeCornea = edge;
          this.initEdge("corneadia", edge, mode ? mode : this.currentMode);
        } else {
          state = false;
        }
      } else {
        state = false;
      }
      if (hasKey(this.currentRecord, `content.data${this.currentEye}.dynamicpupil.pupilArray`)) {
        this.pupilChartState = true;
        this.caculateTrendData =
          this.currentRecord.content[`data${this.currentEye}`]["dynamicpupil"]["pupilArray"];
        let trendData =
          this.currentRecord.content[`data${this.currentEye}`]["dynamicpupil"]["pupilArray"];
        this.caculateTrendData = trendData.map((value) => (value === -1000 ? null : value));
        // this.caculateTrendData = trendData.filter(function(value) {
        //   return value !== -1000;
        // })
      } else {
        this.pupilChartState = false;
      }
      if (state) this.calcDist(edgePupil, edgeCornea);
      this.data2Imgbox = objectCopy(this.dataOrg);
      this.src = this.initPhoto();

      this.uploadThirdParty();
    },
    getInfo: function () {},
    getProc() {},
    uploadThirdParty() {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.currentPatient.thirdData &&
        window.settings.thirdparty.copmany !== "owl"
      ) {
        console.log(
          "upload thirdparty",
          this.currentRecord.content[`data${this.currentEye}`][this.currentMode]
        );
        if (this.currentRecord.content[`data${this.currentEye}`][this.currentMode].uploaded) return;
        let topography3rd = new Topography3rd(
          this.currentPatient,
          this.record,
          this.$store.state.topography.casePath,
          this.currentEye
        );
        topography3rd.normalParamsData(
          null,
          {
            pupilDiameter: this.dataInForm["pupildia"].r,
            corneaDiameter: this.dataInForm["corneadia"].r,
            file: this._initPhoto()
          },
          (error, params, images) => {
            if (error) {
              this.message("pupil cornea params error", "error");
              return;
            }
            logStdout("start send pupilcornea data and images:", params, images);
            window.thirdpartyScript.sendTopgraphicDataAndImages(
              this.currentPatient,
              this.record,
              this.currentEye,
              {
                params,
                images
              },
              (res) => {
                this.$bus.$emit(EVENTS.hideGlobalWatting);
                this.message(
                  `${res.message}${res.detail ? ":" + res.detail : ""}`,
                  res.code === 200 ? "success" : "error"
                );
                if (res.code === 200) {
                  this.record.content[`data${this.currentEye}`].inspectId = res.inspectId;
                  this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia"].uploaded =
                    true;
                  this.$emit("update-record", this.currentRecord, (res) => {
                    logStdout("update record after upload thirdpary data res", res);
                  });
                }
              }
            );
          }
        );
      } else if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.currentPatient.customerId
      ) {
        if (this.currentRecord.content[`data${this.currentEye}`][this.currentMode].uploaded) return;
        let topography3rd = new Topography3rd(
          this.currentPatient,
          this.record,
          this.$store.state.topography.casePath,
          this.currentEye
        );
        topography3rd.normalParamsData(
          null,
          {
            pupilDiameter: this.dataInForm["pupildia"].r,
            corneaDiameter: this.dataInForm["corneadia"].r,
            file: this._initPhoto()
          },
          (error, params, images) => {
            if (error) {
              this.message("pupil cornea params error", "error");
              return;
            }
            logStdout("start send pupilcornea data and images:", params, images);
            window.thirdpartyScript.addStudy(
              this.currentPatient,
              this.record,
              this.currentEye,
              {
                params,
                images
              },
              (res) => {
                this.$bus.$emit(EVENTS.hideGlobalWatting);
                this.message(`${res.message}`, res.status === 200 ? "success" : "error");
                if (res.code === 200) {
                  // this.record.content[`data${this.currentEye}`].inspectId = res.inspectId
                  this.currentRecord.content[`data${this.currentEye}`]["pupilcorneadia"].uploaded =
                    true;
                  this.$emit("update-record", this.currentRecord, (res) => {
                    logStdout("update record after upload thirdpary data res", res);
                  });
                }
              }
            );
          }
        );
      }
    },
    _initPhoto() {
      if (hasKey(this.currentRecord, `content.data${this.currentEye}.${this.currentMode}.photos`)) {
        let photos =
          this.currentRecord.content[`data${this.currentEye}`][this.currentMode]["photos"];
        let photo = photos[0];
        return photo;
      }
      return undefined;
    },
    initPhoto() {
      const { serverip, serverport, sslport, serverssl } = window.server || {};
      let protocol = serverssl === 1 ? "https:" : "http:";
      let port = serverssl === 1 ? sslport : serverport;
      let photo = this._initPhoto();
      return isDefined(photo)
        ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
        : "";
    },
    selectItem(mode) {
      // this.$bus.$emit('pupilCornea-switch')
      if (hasKey(this.currentRecord, `content.data${this.currentEye}.${mode}.photos`)) {
        this.currentMode = mode;
        // this.currentPupilCornea = mode
        window.pupilCorneaMode = mode;
        this.currentOldMode = mode;
        this.initPupilCornea();
      } else {
        this.currentMode = this.currentOldMode;
        this.$emit("show-capture", mode);
      }
    },
    isEdgeChanged(mode, edge) {
      let keys = ["x", "y", "r"];
      if (
        !hasKey(
          this.currentRecord,
          `content.data${this.currentEye}.${this.currentMode}.${mode}.edgeMoved`
        )
      ) {
        return false;
      }
      for (let id = 0; id < keys.length; id++) {
        if (
          !isEqual(
            this.currentRecord.content[`data${this.currentEye}`][this.currentMode][mode].edgeMoved[
              keys[id]
            ],
            edge[keys[id]]
          )
        ) {
          return true;
        }
      }
      return false;
    },
    btnDrawToolChange(val) {
      this.graphMode = val;
    },
    resotreDia(op) {
      if (op === "Restore") {
        this.confirm(this.$t("langcfg.txtConfirm2Restore"))
          .then(() => {
            if (hasKey(this.currentRecord, `content.data${this.currentEye}.${this.currentMode}`)) {
              this.currentRecord.content[`data${this.currentEye}`][this.currentMode][
                "corneadia"
              ].edgeMoved = objectCopy(DEFAULTEDGE);
              this.currentRecord.content[`data${this.currentEye}`][this.currentMode][
                "pupildia"
              ].edgeMoved = objectCopy(DEFAULTEDGE);
              this.initEdge(
                "corneadia",
                this.currentRecord.content[`data${this.currentEye}`][this.currentMode]["corneadia"]
                  .edge,
                this.currentMode
              );
              this.initEdge(
                "pupildia",
                this.currentRecord.content[`data${this.currentEye}`][this.currentMode]["pupildia"]
                  .edge,
                this.currentMode
              );
              this.calcDist(
                this.currentRecord.content[`data${this.currentEye}`][this.currentMode]["corneadia"]
                  .edge,
                this.currentRecord.content[`data${this.currentEye}`][this.currentMode]["pupildia"]
                  .edge
              );
              this.$emit("update-record", this.currentRecord, (res) => {
                this.data2Imgbox = objectCopy(this.dataOrg);
                if (res.message !== "OK") {
                  this.notify(this.$t("langcfg.txtUpdateDataFailed"), "", "error");
                }
              });
            }
            this.graphMode = "Select";
          })
          .catch(() => {
            this.graphMode = "Select";
          });
      }
    }
  },
  computed: {
    ...mapGetters(["dataShowSettings"]),
    src: {
      get: function () {
        return this.initPhoto();
      },
      set: function () {}
    },
    selectLable() {
      return [
        this.$t("langcfg.txtpupilcorneaStatic") + " & " + this.$t("langcfg.txtCornea"),
        this.$t("langcfg.txtpupilcorneaDynamic")
      ];
    }
  }
};
</script>
<style lang="less" scoped>
.pupilcal-highlight {
  background-color: #ffeb3b;
  color: #000;
}

.pupilt12-highlight {
  background-color: #87ceeb;
  color: #000;
}

.footer {
  width: 100%;
  height: 80px;
}

.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}

.nibut {
  position: relative;
}

.border-normal :hover {
  i {
    color: @btn-hover-color;
  }
}

.btn-oprator {
  height: @header-fs+30px;
}

.pupil-cornea-value {
  text-align: left;
}

.el-form /deep/ .el-form-item__label {
  font-size: 25px;
}

.radioContainer {
  padding-top: 10px;
  line-height: 80px;
}

.radioContainer .el-radio {
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
}

.radioContainer .el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}

.data-item {
  width: 500px;
  height: 110px;
  padding-left: 30px;
  text-align: left;
}

.el-select /deep/ input {
  font-size: 30px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}

.el-select-dropdown__item.hover {
  background-color: #44444c;
}

li.el-select-dropdown__item {
  font-size: 40px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}

.el-select-dropdown__item /deep/ span {
  font-size: 25px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}

.aside-content2,
.aside-content1 {
  /deep/ .el-input-number {
    width: 110px;
    height: 40px;
    .el-input {
      .el-input__inner {
        height: 40px;
        font-size: 22px;
        padding-left: 0;
        // color: #000;
      }
    }
    // .el-input.is-disabled .el-input__inner {
    // color: #000;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilCornea.vue